import { TradeScreenTranslations } from './getTradeTranslations';

// Business error codes the BE returns instead of a terminal transfer status.
const FIAT_TRANSFER_ERROR_CODES = {
  OFFER_EXPIRED: 'trading.timeframe.elapsed',
  DEPOSIT_FUNDS_CONSUMED: 'deposit.funds.consumed',
  OFFER_ALREADY_ACCEPTED: 'trade.offer.accepted',
} as const;

// Maps a BE error code to its description; returns undefined for unknown codes.
export const getTransferErrorDescription = (
  errors: string[] | null,
  translations: TradeScreenTranslations,
): string | undefined => {
  const descriptions: Record<string, string> = {
    [FIAT_TRANSFER_ERROR_CODES.OFFER_EXPIRED]:
      translations.fiatTransferOfferExpiredStatusDescription,
    [FIAT_TRANSFER_ERROR_CODES.DEPOSIT_FUNDS_CONSUMED]:
      translations.fiatTransferDepositFundsConsumedStatusDescription,
    [FIAT_TRANSFER_ERROR_CODES.OFFER_ALREADY_ACCEPTED]:
      translations.fiatTransferOfferAcceptedDescription,
  };

  const matchedCode = errors?.find((code) => code in descriptions);

  return matchedCode ? descriptions[matchedCode] : undefined;
};
